import { createRouter, createWebHistory } from 'vue-router';

// Lazy-loaded route components
const Dashboard = () => import('@/pages/Dashboard.vue');
const Welcome = () => import('@/pages/Welcome.vue');
const Projects = () => import('@/pages/Projects.vue');
const NewProject = () => import('@/pages/NewProject.vue');
const ProjectInternal = () => import('@/pages/ProjectInternal.vue');

// Auth pages
const Login = () => import('@/pages/auth/Login.vue');
const Register = () => import('@/pages/auth/Register.vue');
const RegisterComplete = () => import('@/pages/auth/RegisterComplete.vue');
const ForgotPassword = () => import('@/pages/auth/ForgotPassword.vue');
const ResetPassword = () => import('@/pages/auth/ResetPassword.vue');
const VerifyEmail = () => import('@/pages/auth/VerifyEmail.vue');
const ConfirmPassword = () => import('@/pages/auth/ConfirmPassword.vue');

// Settings pages
const Profile = () => import('@/pages/settings/Profile.vue');
const Password = () => import('@/pages/settings/Password.vue');
const Appearance = () => import('@/pages/settings/Appearance.vue');

const routes = [
    {
        path: '/',
        redirect: '/dashboard',
    },
    {
        path: '/welcome',
        name: 'welcome',
        component: Welcome,
        meta: { requiresGuest: true },
    },
    {
        path: '/login',
        name: 'login',
        component: Login,
        meta: { requiresGuest: true },
    },
    {
        path: '/register',
        name: 'register',
        component: Register,
        meta: { requiresGuest: true },
    },
    {
        path: '/register/complete',
        name: 'register.complete',
        component: RegisterComplete,
        meta: { requiresAuth: true },
    },
    {
        path: '/forgot-password',
        name: 'password.request',
        component: ForgotPassword,
        meta: { requiresGuest: true },
    },
    {
        path: '/reset-password/:token',
        name: 'password.reset',
        component: ResetPassword,
        meta: { requiresGuest: true },
    },
    {
        path: '/verify-email',
        name: 'verification.notice',
        component: VerifyEmail,
        meta: { requiresAuth: true },
    },
    {
        path: '/confirm-password',
        name: 'password.confirm',
        component: ConfirmPassword,
        meta: { requiresAuth: true },
    },
    {
        path: '/dashboard',
        name: 'dashboard',
        component: Dashboard,
        meta: { requiresAuth: true },
    },
    {
        path: '/projects',
        name: 'projects',
        component: Projects,
        meta: { requiresAuth: true },
    },
    {
        path: '/projects/new',
        name: 'projects.new',
        component: NewProject,
        meta: { requiresAuth: true },
    },
    {
        path: '/new-project',
        redirect: '/projects/new',
    },
    {
        path: '/projects/:id',
        name: 'projects.show',
        component: ProjectInternal,
        meta: { requiresAuth: true },
    },
    {
        path: '/project-internal/:id',
        redirect: to => `/projects/${to.params.id}`,
    },
    {
        path: '/settings/profile',
        name: 'profile.edit',
        component: Profile,
        meta: { requiresAuth: true },
    },
    {
        path: '/settings/password',
        name: 'password.edit',
        component: Password,
        meta: { requiresAuth: true },
    },
    {
        path: '/settings/appearance',
        name: 'appearance',
        component: Appearance,
        meta: { requiresAuth: true },
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else if (to.hash) {
            return { el: to.hash };
        } else {
            return { top: 0 };
        }
    },
});

// Navigation guards
router.beforeEach((to, from, next) => {
    const token = localStorage.getItem('auth_token');
    const isAuthenticated = !!token;

    if (to.meta.requiresAuth && !isAuthenticated) {
        // Redirect to login if route requires auth and user is not authenticated
        next({ name: 'login', query: { redirect: to.fullPath } });
    } else if (to.meta.requiresGuest && isAuthenticated) {
        // Redirect to dashboard if route is for guests only and user is authenticated
        next({ name: 'dashboard' });
    } else {
        next();
    }
});

export default router;
